export default __webpack_public_path__ + "ce61b8b68994802f2e55b64c5e69a450.ttf";